export default __webpack_public_path__ + "static/media/miyo-bee.23bd072a.svg";